<template>
    <v-menu scrim location="center" transition="scale-transition">

        <!-- Gallery Tile -->
        <template v-slot:activator="{ props }">

            <AssetItem
                v-if="hasOnlyOne"
                :asset="firstAsset"
                :context="true" 
                :overflow="!isInputAsset(firstAsset)"
                @select="handleSelect" />

            <div 
                v-else
                v-bind="props" 
                class="flow-item-gallery-activator">

                <v-card 
                    elevation="3" 
                    class="flow-item-gallery-tile" 
                    :class="{ 'flow-item-gallery-tile-lighter': lighter }">
                    +{{ count }}
                </v-card>

            </div>

        </template>

        <v-card class="flow-item-gallery">
            <div 
                v-for="(asset, index) in assets" 
                class="flow-item-gallery-frame"
                :key="index">

                <AssetItem     
                    :asset="asset" 
                    :context="true" 
                    :overflow="!isInputAsset(asset)"
                    @select="handleSelect" />

            </div>
        </v-card>   
        
    </v-menu>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'
import AssetItem from '@/components/common/asset/AssetItem.vue'

    export default {
        name: 'FlowItemGallery',
        components: {
            AssetItem
        },
        props: {
            assets: {
                type: Array,
                default: []
            },
            lighter: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('flows', [
                'isInputAsset'
            ]),
            hasOnlyOne() {
                return this.count == 1
            },
            hasMultiple() {
                return this.count > 1
            },
            count() {
                return this.assets.length
            },
            firstAsset() {
                if (this.count > 0) return this.assets[0]
                return null
            },
        },
        emits: ['select', 'rate', 'share', 'download', 'delete'],
        methods: {
            handleSelect(asset) {
                this.$emit('select', asset)
            },
            handleRate(asset) {
                this.$emit('rate', asset)
            },
            handleShare(asset) {
                this.$emit('share', asset)
            },
            handleDownload(asset) {
                this.$emit('download', asset)
            },
            handleDelete(asset) {
                this.$emit('delete', asset)
            }
        }
    }
</script>

<style scoped>
    .flow-item-gallery-activator {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flow-item-gallery-tile {
        width: 60%;
        height: 60%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        font-weight: bold;
        background-color: rgba(var(--v-theme-lightbase), 0.8);
        transition: background-color 0.3s ease;
    }

    .flow-item-gallery-tile:hover {
        background-color: rgba(var(--v-theme-darkerbase), 1.0);
        cursor: pointer;
    }

    .flow-item-gallery-tile-lighter {
        background-color: rgba(var(--v-theme-lightbase), 0.8);
    }

    .flow-item-gallery {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        justify-content: center;
        background-color: rgb(var(--v-theme-lightbase)) !important;
        padding: 15px;
        border-radius: 8px;
    }

    .flow-item-gallery-frame {
        min-height: 200px;
        aspect-ratio: 1 / 1;
    }

    @media (max-width: 1400px)
    {
        .flow-item-gallery-tile {
            font-size: 24px;
        }
    }

    @media (max-width: 600px)
    {
        .flow-item-gallery {
            grid-template-columns: repeat(1, 1fr);
        }
    }
</style>